import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/nextjs';

import { showModal } from '../actions/modal';
import { OUTDATED } from '../constants';
import packageInfo from '../../package.json';

export default function* fetchErrorHandler(action) {
  try {
    const { error, message } = action.payload;

    const eventData = {
      error,
      message,
      timestamp: new Date().toISOString(),
      packageVersion: packageInfo.version,
      environment: process.env.NODE_ENV,
    };

    if (typeof window !== 'undefined' && window.location) {
      eventData.url = window.location.href;
    }
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      eventData.userAgent = navigator.userAgent;
    }

    Sentry.withScope((scope) => {
      if (error && error.status) {
        scope.setTag('error_status', error.status);
      }
      if (action.type) {
        scope.setTag('action_type', action.type);
      }
      scope.setExtra('action_payload', action.payload);

      Sentry.captureException(eventData, {
        level: 'error',
      });
    });

    if (error?.status === 410 && error?.data?.message === OUTDATED && packageInfo) {
      yield put(
        showModal('SHOW_AVAILABLE_UPDATES', {
          data: JSON.parse(decodeURIComponent(error.data.data)),
          version: packageInfo.version,
        }),
      );
      return;
    }
  } catch (err) {
    Sentry.captureException(err);
  }
}
